import styles from './CareCuesEmpty.module.scss';

const CareCuesEmpty = () => {
  return (
    <div className={styles.care_cues_empty}>
      <div className={styles.care_cues_empty__content}>
        <h1 className={styles.care_cues_empty__content__heading}>No CareCues</h1>
        <p className={styles.care_cues_empty__content__heading_subtext}>
          As new CareCues are received, they will appear here for review.
        </p>
      </div>
    </div>
  );
};

export default CareCuesEmpty;
